import React from "react";
import styles from './index.module.scss';
import Touxiang from '@src/assets/imgs/login/touxiang.png'

import { useNavigate } from "react-router-dom";

//导入antd
import { Button, message } from 'antd';
// 导入react-redux
import { useSelector,useDispatch } from "react-redux";
import { clearState } from "@src/store/actions/user";

export const HeaderLogin = (props: any) => {
    const { setLoginVisible } = props;
    const isLogin = useSelector((state: any) => state.user.userInfo.token);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //获取存在sessionStorage中userInfo对象中的loginName
    const loginName = useSelector((state: any) => state.user.userInfo.loginName);

    //退出登录
    const logout = () => {
        message.success('退出登录成功',1);
        //清空sessionStorage中的userInfo对象
        dispatch(clearState());
        navigate('/', { replace: true })
    }

    return (
        <div>
            {/* 如果isLogin为true，显示用户信息，否则显示登录按钮 */}
            {isLogin ? (
                <div className={styles.header_login}>
                    <div className={styles.header_login_user}>
                        <img src={Touxiang} className={styles.header_login_user_img} />
                        <div className={styles.header_login_user_name}>{ loginName }</div>
                        {/* 退出登录按钮 */}
                        <Button className={styles.header_login_user_logout} type="primary" onClick={() => logout()}>退出登录</Button>
                    </div>
                </div>
            ) : (
                <div className={styles.header_unlogin}>
                    <Button className={styles.header_unlogin_btn} type="primary" onClick={() => setLoginVisible(true)}>登录</Button>
                </div>
            )}
        </div>
    )
}
